import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeaderNotificationIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.77 17.77L20.45 15.12V8.70001C20.45 4.05001 16.66 0.26001 12 0.26001C7.34003 0.26001 3.55003 4.05001 3.55003 8.70001V15.12L2.23003 17.77C1.94003 18.35 1.97003 19.02 2.31003 19.57C2.65003 20.12 3.24003 20.45 3.88003 20.45H8.03003C8.38003 22.33 10.03 23.75 12 23.75C13.97 23.75 15.62 22.33 15.97 20.45H20.12C20.77 20.45 21.35 20.12 21.69 19.57C22.03 19.02 22.06 18.35 21.77 17.77ZM12 22.25C10.85 22.25 9.88003 21.49 9.56003 20.45H14.44C14.12 21.49 13.15 22.25 12 22.25ZM20.42 18.78C20.38 18.84 20.29 18.95 20.12 18.95H3.88003C3.71003 18.95 3.62003 18.85 3.58003 18.78C3.54003 18.72 3.49003 18.59 3.56003 18.44L4.96003 15.63C5.01003 15.53 5.04003 15.41 5.04003 15.3V8.70001C5.04003 4.87001 8.16003 1.76001 11.99 1.76001C15.82 1.76001 18.94 4.87001 18.94 8.70001V15.3C18.94 15.42 18.97 15.53 19.02 15.63L20.42 18.44C20.5 18.59 20.44 18.72 20.41 18.78H20.42Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HeaderNotificationIcon.displayName = 'HeaderNotificationIcon';
